import { haptic } from '../lib/telegram';

// 'tienda' is a full-screen route reached from Inicio/Perfil, not a bottom-bar
// tab — it's a valid key so setTab('tienda') typechecks, but never in STAFF_TABS.
export type TabKey = 'inicio' | 'eventos' | 'ofertas' | 'pagos' | 'dispo' | 'ops' | 'perfil' | 'tienda';

interface TabBarProps {
  active: TabKey;
  onChange: (k: TabKey) => void;
  /** When true, render the Ops tab between Pagos and Perfil. Driven by AuthUser.isAdmin. */
  showOps?: boolean;
}

const STAFF_TABS: { key: TabKey; ic: string; label: string }[] = [
  { key: 'inicio', ic: '🏠', label: 'Inicio' },
  { key: 'eventos', ic: '📅', label: 'Eventos' },
  { key: 'ofertas', ic: '🎁', label: 'Ofertas' },
  { key: 'pagos', ic: '💵', label: 'Pagos' },
  { key: 'dispo', ic: '📋', label: 'Disponib.' },
  { key: 'perfil', ic: '👤', label: 'Perfil' },
];

const OPS_TAB: { key: TabKey; ic: string; label: string } = {
  key: 'ops', ic: '🛡️', label: 'Ops',
};

export function TabBar({ active, onChange, showOps }: TabBarProps) {
  // Splice Ops in just before Perfil so admins see it where they expect: ...
  // Pagos · Disponib · Ops · Perfil. Staff users see the unmodified strip.
  const tabs = showOps
    ? [...STAFF_TABS.slice(0, -1), OPS_TAB, STAFF_TABS[STAFF_TABS.length - 1]]
    : STAFF_TABS;

  return (
    <nav class="tab-bar" style={{ gridTemplateColumns: `repeat(${tabs.length}, 1fr)` }}>
      {tabs.map((t) => (
        <button
          key={t.key}
          class={`tab ${active === t.key ? 'active' : ''}`}
          onClick={() => {
            if (active !== t.key) {
              haptic('light');
              onChange(t.key);
            }
          }}
        >
          <div class="ic">{t.ic}</div>
          <div>{t.label}</div>
        </button>
      ))}
    </nav>
  );
}
